/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.alert-info\":\"Blå sirkel med bokstaven \\\"I\\\"\"}");